import update from 'immutability-helper'
import { RESET, RECV_SELF_ID, RECV_ROOM } from '../actions/main'
import { toIntMap } from '../../lib/util'
import { initUsers, initUser } from '../../lib/user'
import { initialState as browserState, browserReducer } from './browser'
import { initialState as settingState, settingReducer } from './setting'
import { initialState as roomsState, roomsReducer } from './rooms'
import { initialState as appearState, appearReducer } from './appear'
import { initialState as chatState, chatReducer } from './chat'
import { initialState as teamsState, teamsReducer } from './teams'
import { initialState as ruleState, ruleReducer } from './rule'
import { initialState as buttonState, buttonReducer } from './button'
import { initialState as scoreState, scoreReducer } from './score'
import { initialState as boardState, boardReducer } from './board'
import { initialState as timerState, timerReducer } from './timer'

const initialState = {
  browser: browserState,
  setting: settingState,
  rooms: roomsState,
  appear: appearState,
  chat: chatState,
  teams: teamsState,
  rule: ruleState,
  button: buttonState,
  score: scoreState,
  board: boardState,
  timer: timerState,
  selfID: null,
  roomNo: null,
  tag: {
    title: '',
    password: ''
  },
  users: initUsers,
  user: initUser,
  summary: {
    masterName: '',
    numPlayers: 0,
    playerNames: [],
    numObservers: 0,
    observerNames: []
  }
}

const recvRoom = (state, action) => {
  const room = action.room
  const users = toIntMap(room.users)
  return update(state, {
    roomNo: { $set: room.no },
    tag: { $set: room.tag },
    users: { $set: users },
    user: { $set: users.get(state.selfID) },
    summary: { $set: room.summary },
    teams: { $set: teamsReducer(state.teams, action) }
  })
}

export const mainReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return update(initialState, {
        browser: { $set: state.browser },
        setting: { $set: state.setting },
        selfID: { $set: state.selfID },
        rooms: { $set: state.rooms }
      })
    case RECV_SELF_ID:
      return update(state, { selfID: { $set: action.selfID } })
    case RECV_ROOM:
      return recvRoom(state, action)
    default:
      return update(state, {
        browser: { $set: browserReducer(state.browser, action) },
        setting: { $set: settingReducer(state.setting, action) },
        rooms: { $set: roomsReducer(state.rooms, action) },
        appear: { $set: appearReducer(state.appear, action) },
        chat: { $set: chatReducer(state.chat, action) },
        teams: { $set: teamsReducer(state.teams, action) },
        rule: { $set: ruleReducer(state.rule, action) },
        button: { $set: buttonReducer(state.button, action) },
        score: { $set: scoreReducer(state.score, action) },
        board: { $set: boardReducer(state.board, action) },
        timer: { $set: timerReducer(state.timer, action) }
      })
  }
}
